import { render, staticRenderFns } from "./DosesTab.vue?vue&type=template&id=c3372078"
import script from "./DosesTab.vue?vue&type=script&lang=js"
export * from "./DosesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports